import { Suspense } from 'react'
import { ProgressBarSuspenseFallback } from '@vivaldis/web-ui'
import { Routes, Route } from 'react-router-dom'
import { lazyOrReloadPage } from '../../utils/lazyOrReloadPage'

const StartUpDocumentAdditionalBenefits = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "StartUpDocumentAdditionalBenefits" */ './screens/StartUpDocumentAdditionalBenefits'
    )
)
const StartUpDocumentContractInformation = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "StartUpDocumentContractInformation" */ './screens/StartUpDocumentContractInformation'
    )
)
const StartUpDocumentList = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "StartUpDocumentList" */ './screens/StartUpDocumentList'
    )
)
const ViewStartUpDocument = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "ViewStartUpDocument" */ './screens/ViewStartUpDocument'
    )
)

export const StartUpDocumentsRoutes = () => {
  return (
    <Suspense fallback={ProgressBarSuspenseFallback}>
      <Routes>
        <Route path="/" element={<StartUpDocumentList />} />
        <Route
          path="additional-benefits/:startUpDocumentId"
          element={<StartUpDocumentAdditionalBenefits />}
        />
        <Route
          path="contract-information/:startUpDocumentId"
          element={<StartUpDocumentContractInformation />}
        />
        <Route
          path="view-start-up-document/:startUpDocumentId"
          element={<ViewStartUpDocument />}
        />
      </Routes>
    </Suspense>
  )
}
